module.exports = __webpack_public_path__ + "b3aa128c2c27b55fc8e8795a9c8ecf2a.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2024-10-31/whats-new.html
// module id = 2253
// module chunks = 0